import config from '../config';
import fetch from 'cross-fetch';
import store from 'store2';

import {
  removeJobCardById,
  updateEnableForJobCardById,
  loadAllColorsOfJobCards,
  loadJobCardById,
  addNewJobCard,
  updateJobCardById,
  getAllJobCards
} from '../actions/jobCards';
import { addNotification as notify } from 'reapop';
import { push } from 'react-router-redux';

export function deleteJobCardById(data) {
    return (dispatch) => {
      const userAuth = store.get('user');
      if (userAuth && userAuth.api_token) {
        return fetch(`${config.apiEndpoint}/jobCard/${data.id}`, {
            method: 'DELETE',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `bearer ${userAuth.api_token}`
            },
            credentials: 'same-origin'
          })
          .then((response) => {
            return response.json();
          })
          .then(json => {
            if (json) {
              dispatch(removeJobCardById({ id: data.id  }));
              dispatch(notify({
                title: 'Delete Job Card',
                message: 'Job Card deleted successfully',
                status: 'success',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
            }
          })
      }
    }
}

export function updatePropertyEnableForJobCardById(id, data) {
    return (dispatch) => {
      const userAuth = store.get('user');
      if (userAuth && userAuth.api_token) {
        return fetch(`${config.apiEndpoint}/jobCard/changeStatus/${id}`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `bearer ${userAuth.api_token}`
            },
            credentials: 'same-origin'
          })
          .then((response) => {
            return response.json();
          })
          .then(json => {
            if (json) {
              dispatch(updateEnableForJobCardById({
                id,
                data,
              }));
            }
          })
      }
    }
}

export function fetchAllColorsOfJobCards() {
    return (dispatch) => {
      const userAuth = store.get('user');
      if (userAuth && userAuth.api_token) {
        return fetch(`${config.apiEndpoint}/jobCard/getJobColors`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `bearer ${userAuth.api_token}`
            },
            credentials: 'same-origin'
          })
          .then((response) => {
            return response.json();
          })
          .then(json => {
            if (json) {
              dispatch(loadAllColorsOfJobCards(json));
            }
          })
      }
    }
}

export function fetchJobCardById(data) {
    return (dispatch) => {
      const userAuth = store.get('user');
      if (userAuth && userAuth.api_token) {
        return fetch(`${config.apiEndpoint}/jobCard/${data.id}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `bearer ${userAuth.api_token}`
            },
            credentials: 'same-origin'
          })
          .then((response) => {
            return response.json();
          })
          .then(json => {
            if (json) {
              dispatch(loadJobCardById({ currentJobCard: json }));
            }
          })
      }
    }
}

export function addJobCard(data) {
    return (dispatch) => {
      const userAuth = store.get('user');
      if (userAuth && userAuth.api_token) {
        return fetch(`${config.apiEndpoint}/jobCard/addJobCard`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `bearer ${userAuth.api_token}`
            },
            credentials: 'same-origin'
          })
          .then((response) => {
            return response.json();
          })
          .then(json => {
            if (json) {
              dispatch(addNewJobCard(json));
              dispatch(push('/pages/job-cards'));
              dispatch(notify({
                title: 'Add Job Card',
                message: 'Job card added successfully',
                status: 'success',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
            }
          })
          .catch(response => {
            dispatch(notify({
              title: 'Add Job Card',
              message: 'Failed to add new job card',
              status: 'error',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          });
      }
    }
}

export function setJobCardById(id, data) {
    return (dispatch) => {
      const userAuth = store.get('user');
      if (userAuth && userAuth.api_token) {
        return fetch(`${config.apiEndpoint}/jobCard/updateJobCard/${id}`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `bearer ${userAuth.api_token}`
            },
            credentials: 'same-origin'
          })
          .then((response) => {
            return response.json();
          })
          .then(json => {
            if (json) {
              dispatch(push('/pages/job-cards'));
              dispatch(notify({
                title: 'Edit Job Card',
                message: 'Job card edited successfully',
                status: 'success',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
            }
          })
          .catch(response => {
            dispatch(notify({
              title: 'Edit Job Card',
              message: 'Failed to edit job card',
              status: 'error',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          });
      }
    }
}

export function getJobCards() {
  return dispatch => {
    const userAuth = store.get('user');
    return fetch(`${config.apiEndpoint}/jobCard`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
      .then((response) => {
        return response.json();
      })
      .then(json => {
        if (json) {
          dispatch(getAllJobCards({ list: json }));
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/jobCards.js